/**
 * @prettier
 * @flow
 */
import TextField from '@material-ui/core/TextField';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { trim as _trim } from 'src/utils/string/trim';
import { upperCase as _upperCase } from 'src/utils/string/upperCase';

export const TransformedTextField = React.forwardRef<any, any>(function TransformedTextField({ value, onChange, trim, upperCase, ...props }, ref) {
    const [inputValue, setInputValue] = useState(transformToInput(value)); // Separate form value from input value
    useEffect(() => {
        let oldValue = transformToOutput(inputValue, trim, upperCase);
        if (value !== oldValue) setInputValue(transformToInput(value));
    }, [value, trim, upperCase]);
    return (
        <TextField
            {...props}
            value={inputValue}
            onChange={(e) => {
                setInputValue(e.target.value);
                onChange(transformToOutput(e.target.value, trim, upperCase));
            }}
        />
    );
});

function transformToInput(value?: ?string): string {
    return value ?? '';
}

export function transformToOutput(value?: ?string, trim?: boolean, upperCase?: boolean): ?string {
    let outputValue = value;
    if (trim) outputValue = _trim(outputValue);
    if (upperCase) outputValue = _upperCase(outputValue);
    return !outputValue ? null : outputValue;
}
